import {Component, computed, effect, inject, viewChild} from '@angular/core';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';
import {PageGridComponent} from '../../../shared/components/page-grid/page-grid.component';
import {GridEventOutput, GridModel} from '../../../shared/model/page-grid';
import {KtTripsFilterService} from '../../service/kt-trips-filter.service';
import {KtTripsGridService} from '../../service/kt-trips-grid.service';
import {IKtTripListItem} from '../../interfaces/kt-trip.interface';

@Component({
  selector: 'app-kt-trips-list',
  templateUrl: './kt-trips-list.component.html',
  standalone: false,
})
export class KtTripsListComponent {
  private readonly filterService = inject(KtTripsFilterService);
  private readonly gridService = inject(KtTripsGridService);
  private readonly datePipe = inject(DatePipe);
  private readonly router = inject(Router);

  protected readonly gridRef = viewChild.required(PageGridComponent);

  protected readonly gridConfig = computed<GridModel<IKtTripListItem>>(() => ({
    gridDataTestId: 'kt-trips-list',
    gridTitle: 'KT Trips',
    defaultPageSize: 25,
    columns: [
      {
        columnProperty: 'id',
        columnHeader: 'Trip ID',
        sort: true,
        clickable: true,
        linkEventFunction: (item: IKtTripListItem) => `/KtTrip/${item.id}`,
      },
      {
        columnProperty: 'tripReference',
        columnHeader: 'Trip Reference',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'mainClientName',
        columnHeader: 'Client',
        sort: true,
        textLeft: true,
        extraWidth: true,
      },
      {
        columnProperty: 'mainClientEmail',
        columnHeader: 'Client Email',
        sort: false,
        textLeft: true,
        extraWidth: true,
        wrapContent: true,
      },
      {
        columnProperty: 'agentName',
        columnHeader: 'Agent',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'erpOrderNumber',
        columnHeader: 'ERP Order #',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'vendorNames',
        columnHeader: 'Vendors',
        sort: false,
        textLeft: true,
        extraWidth: true,
      },
      {
        columnProperty: 'bookedDate',
        columnHeader: 'Booked Date',
        sort: true,
        processData: (item) => this.datePipe.transform(item, 'M/dd/yyyy') ?? '',
      },
      {
        columnProperty: 'tripStartDate',
        columnHeader: 'Start Date',
        sort: true,
        processData: (item) => item ? (this.datePipe.transform(item, 'M/dd/yyyy') ?? '') : '',
      },
      {
        columnProperty: 'numberOfDays',
        columnHeader: 'Days',
        sort: false,
      },
      {
        columnProperty: 'isCancelled',
        columnHeader: 'Cancelled',
        sort: false,
        processData: (item: any) => item ? 'Yes' : 'No',
      },
    ],
    gridGetService: this.gridService,
  }));

  constructor() {
    effect(() => {
      const filters = this.filterService.filtersValue();
      if (!filters.ReloadGrid) return;
      this.gridRef().getItems();
    });
  }

  protected handleColumnClick(event: GridEventOutput<IKtTripListItem>): void {
    if (event.column === 'id') {
      this.router.navigate(['/KtTrip', event.item.id]);
    }
  }
}
